<template>
    <div
      class="studentPortal"
      :class="{
        'studentPortal--dark': dark,
      }"
    >
      <Header :view="ViewMode" @alterar-valor="alterarValor" />
      <main class="student-portal-main-content">
        <RouterView />
      </main>
      
      <Footer :view="ViewMode" />
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex'
  import { syncAdminModeFromTypeBusiness } from '@/utils/corporate/adminDashboardMode'
  
  import Header from '@/components/Student/Dashboard_Unique/Header/Header'
  import Footer from '@/components/Student/Dashboard_Unique/Footer/Footer'
  import apiWebsite from '@/utils/portal/website'
  import apiPortalUser from '@/utils/portal/user.js'
  import { applyWebsiteFavicon } from '@/utils/websiteBranding'
  import { isPortalLayoutDark } from '@/utils/portalLayoutTheme'
  
  export default {
    data() {
      return {
        ViewMode: false,
        dataCourses: null,
      }
    },
    computed: {
      ...mapState(['token', 'dark', 'websites', 'portalDarkManual']),
      ...mapState('portal', ['dataWebsitePortal2']),
    },
    methods: {
      ...mapActions(['toggleDarkMode', 'storeUser']),
      ...mapActions('portal', ['storeDataWebsitePortal2']),

      alterarValor(novoValor) {
        this.toggleDarkMode({ dark: !this.dark, manual: true })
      },

      applyPortalLayout(source) {
        if (this.portalDarkManual) return
        const dark = isPortalLayoutDark(source?.typeLayoutPortal)
        if (dark === null) return
        this.toggleDarkMode({ dark })
      },

      async refreshPortalUser() {
        if (!this.token) return
        try {
          const user = await apiPortalUser.getDataUser(this.token)
          this.storeUser({ user })
        } catch (error) {
          console.error('Erro ao carregar dados do usuário do portal:', error)
        }
      },

      async getDataWebsite() {
        try {
          const response = await apiWebsite.getDataWebsite(this.token)
          console.log('Dados da API:', response)
          this.storeDataWebsitePortal2({dataWebsitePortal2: response})
          applyWebsiteFavicon(response)
          this.applyPortalLayout(response)

        } catch (error) {
          console.error('Erro ao carregar dados do site:', error)
        }
      },
    },
    watch: {
      ViewMode(novoValor) {
        this.ViewMode = novoValor
      },
    },
    components: {
      Header,
      Footer,
    },
    async created() {
      syncAdminModeFromTypeBusiness(this.websites)
      this.applyPortalLayout(this.dataWebsitePortal2 || this.websites)
      await this.refreshPortalUser()
      this.getDataWebsite()
    },
  }
  </script>
  
  <style scoped>
  /*
   * Portal aluno: página cresce com o conteúdo (scroll no documento).
   * Footer fica no fim do fluxo — não preso à viewport.
   */
  .studentPortal {
    --dash-bg: #F5F7FA;
    --dash-bg-elevated: #ffffff;
    --dash-text: #111827;
    --dash-text-muted: #6b7280;
    --dash-border: rgba(15, 23, 42, 0.08);
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    height: auto;
    background: var(--dash-bg);
    min-width: 0;
    overflow-x: hidden;
  }

  .studentPortal.studentPortal--dark {
    --dash-bg: #0f0e12;
    --dash-bg-elevated: #1a191f;
    --dash-text: #f3f4f6;
    --dash-text-muted: #9ca3af;
    --dash-border: rgba(255, 255, 255, 0.08);
    background: var(--dash-bg);
  }

  @media (max-width: 959px) {
    .studentPortal {
      background: var(--dash-bg);
    }
  }

  .student-portal-main-content {
    flex: 1 0 auto;
    min-height: 0;
    width: 100%;
  }

  .student-portal-main-content > div {
    min-height: 0;
    height: auto;
  }
  </style>
  